<template>
<div style="width:100%;height:100%;">
  <div>11111</div>
  <input type="text" name="lastname" v-model="inputtext" @keyup="keydown">
</div>
</template>
<script>
export default {
  name: "orderFilter",
  data() {
    return {
      inputtext:"",
      isItouch:true
    }
  },
  created() {},
  deactivated() {
    //document.removeEventListener("keyup", this.keydown, false);
  },
  activated() {
    var v = this;
    //document.addEventListener("keyup", this.keydown, false);
  },
  methods: {
    keydown(e) {
      var v = this;
      var nextCode = e.keyCode;
      if(!v.isItouch) return;
      if(e.which == 13 || e.which == 8 || e.keyCode == 108){ // 若是enter和回退键 那就不处理
        return;
      }

      if(v.inputtext.length >0){
        return;
      }

      // v

      // if((nextCode >=48 && nextCode <=105) || (nextCode >=106 && nextCode <=111) || (nextCode >=189 && nextCode <=192)){
      //   v.inputtext += String.fromCharCode(nextCode);
      // }

      v.inputtext += e.key;

      // mui.alert("当前输入：" + nextCode,"错误提示",function(){
      // });

      // if(e.key !="Enter" && )
      // mui.alert("当前输入：" + e.key,"错误提示",function(){
      //   v.inputtext += e.key;
      // });
    }
  },
  watch:{
    
  }
}

</script>
<style scoped>
.gyshadow {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6);
    z-index: 2;
}
.shadow_div{
  position: fixed; width: 100%;z-index:3;top:35%;padding:15px; border-radius: 5px;
}
.shadow_content{
  margin:0 auto;width:95%;background: #fff;border-radius: 5px;
}
.iconfont{
	color:#2F86F3;
	font-size: 25px;
}
.circle{
	text-align: center;
}
.nowrap{
  white-space: nowrap;
}
.backLine{
  height: 3px;
  background-color: #F6F6F6;
}
.iconStatus1 .iconfont{
  color: #33CCBD;
}
.iconStatus2 .iconfont{
  color: #ECAC62;
}

</style>



// WEBPACK FOOTER //
// src/components/test.vue